import { RowRequestDto } from '@asset-metrix/portal-gateway-client-js';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const executeTableRowRequest = async ({
  widgetId,
  data,
}: {
  widgetId: string;
  data: RowRequestDto;
}) => {
  const response = await portalGatewayClient.table.executeRowRequest(
    widgetId,
    data
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error executing row request'),
      response
    );
  }
};
